import { designEn } from './design.en.js';
import { kioskBoardEn } from './kioskBoard.en.js';
import { foodEn } from './food.en.js';
import { familyEn } from './family.en.js';
import { kamersEn } from './kamers.en.js';
import { kioskRemindersEn } from './reminders.en.js';
import { kioskWeatherEn } from './kioskWeather.en.js';
import { kioskTimerEn } from './kioskTimer.en.js';
import { hallwayEn } from './hallway.en.js';
import { kioskPrivacyEn } from './kioskPrivacy.en.js';
import { kioskMoveEn } from './kioskMove.en.js';
import { readAloudEn } from './readAloud.en.js';
import { todoEn } from './todo.en.js';
// Engels (F4). Zelfde vorm als nl; het type dwingt volledigheid af.
export const en = {
    locale: 'en-GB',
    weekdays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    weekdaysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    design: designEn,
    food: foodEn,
    family: familyEn,
    kamers: kamersEn,
    reminders: kioskRemindersEn,
    // 0026 weer: losse woorden op het bord (de zinnen maakt de server).
    weather: kioskWeatherEn,
    // Timer op het bord (oprichter 1 okt 2026).
    timer: kioskTimerEn,
    // Golf 6b (0043): het bord in de gang van een gedeelde woning (hallway.en.ts).
    hallway: hallwayEn,
    privacy: kioskPrivacyEn,
    move: kioskMoveEn,
    readAloud: readAloudEn,
    // 0058: to-do's onder de taken van een lid (todo.en.ts).
    todo: todoEn,
    common: {
        adjustBoard: 'Adjust',
        refreshBoard: 'Refresh',
        create: 'Create new',
        agendaBoard: 'Calendar',
        today: 'Today',
        tomorrow: 'Tomorrow',
        now: 'Now',
        later: 'Later',
        done: 'Done',
        cancel: 'Cancel',
        confirm: 'Confirm',
        back: 'Back',
        close: 'Close',
    },
    kiosk: {
        ...kioskBoardEn,
        agenda: 'Calendar',
        tasks: 'Tasks',
        rewards: 'Rewards',
        nothingToday: 'Nothing planned today',
        nothingMore: 'Nothing more today',
        noTasks: 'No tasks for today',
        allDone: 'All done!',
        /** Rustig, buiten het thema Kinderen. */
        allDoneCalm: 'Everything is done',
        allDay: 'All day',
        everyone: 'Everyone',
        next: 'Up next',
        startsIn: 'in {time}',
        busyFor: '{time} left',
        minutesShort: '{count} min',
        hoursShort: '{h} h {m} min',
        tasksProgress: '{done} of {total} done',
        pairTitle: 'Pair this tablet',
        pairHint: 'Enter this code on your phone:',
        pairScan: 'Or scan the QR code with your phone',
        pairWaiting: 'Waiting for approval…',
        pairStarting: 'Getting a code…',
        pairExpired: 'Code expired, getting a new one…',
        pairNoConnection: 'No connection to the server, retrying…',
        pairQrClaiming: 'Connecting with the QR code…',
        pairQrInvalid: 'This QR code has expired or was already used. Create a new one in the parent app, or connect with the code on this screen.',
        pairQrLimit: 'Your plan can’t take another tablet. Disconnect another tablet in the parent app first.',
        pairQrBusy: 'A few too many tries. Wait a minute, then scan the QR code again.',
        pairQrOffline: 'No connection, so the QR code didn’t work. Scan it again, or connect with the code on this screen.',
        offline: 'No connection, last update {time}',
        offlineBadge: 'No connection',
        renderFailed: 'The board cannot show the calendar right now and will try again.',
        checkInApp: 'Check this tablet in the parent app',
        staleData: 'No current data',
        standaloneTitle: 'Add the family board to your Home Screen',
        standaloneBody: 'In Safari tap Share, then "Add to Home Screen". Open the board from that icon afterwards, otherwise the pairing is not kept.',
        points: { one: '{count} point', other: '{count} points' },
        tasksLeft: { one: '{count} task left', other: '{count} tasks left' },
        paused: 'Read only',
        pausedHint: 'The board is look-only for now. Ticking things off works again later.',
    },
    web: {
        appName: 'AMUMIN Family Board',
        loginTitle: 'Sign in',
        email: 'Email address',
        password: 'Password',
        login: 'Sign in',
        forgotPassword: 'Forgot your password?',
        noAccount: 'No account yet?',
        register: 'Create account',
        save: 'Save',
        add: 'Add',
        edit: 'Edit',
        remove: 'Delete',
        loading: 'Loading…',
        retry: 'Try again',
        close: 'Close',
        reload: 'Reload',
        none: 'None',
        errorGeneric: 'Something went wrong. Please try again.',
        errorNetwork: 'No connection to the server.',
        errorNotFound: 'This page does not exist.',
        moduleOff: 'This part is turned off for your family.',
        /** 0023/0043: dit lid geeft zelf toestemming (consent_self_required). */
        consentSelfRequired: 'Someone aged 16 or older gives consent for this themselves. Check the ages under Members, then try again.',
        versionConflict: 'Someone else changed this in the meantime. The list has been reloaded; please try again.',
        rateLimited: 'Too many attempts. Try again in {seconds} seconds.',
        sessionExpired: 'Your session has expired. Please sign in again.',
        nav: {
            today: 'Today',
            agenda: 'Calendar',
            members: 'Members',
            devices: 'Devices',
            security: 'Security',
            household: 'Household',
            logout: 'Sign out',
        },
        timeInAmsterdam: 'Time in Amsterdam',
        browserZoneDiffers: 'Your browser is in a different time zone; all times here are Amsterdam time.',
        householdSwitch: 'Active household',
        sharedComputer: 'Shared or public computer',
        sharedComputerHint: 'Your session expires after 24 hours and this browser will not be trusted.',
        stayLoggedIn: 'Stay signed in',
        invalidCredentials: 'Email address or password is incorrect.',
        emailNotVerified: 'Please confirm your email address first using the link in the email.',
        outsideTrustedNetwork: 'You are outside a trusted network. Sign in again with your password and an email code.',
        forgetToLogout: 'Remember to sign out when you are done.',
        householdPaused: 'Your family board is read-only for now. Changes are not possible.',
        lockedOut: 'Too many failed attempts. Please try again later.',
        codeTitle: 'Email code',
        codeIntro: 'We sent a 6-digit code to {email}. It is valid for 10 minutes.',
        codeLabel: 'Code from the email',
        codeInvalid: 'Enter the 6 digits from the email.',
        codeWrong: 'That code is not correct. {count} attempts left.',
        codeWrongPlain: 'That code is not correct.',
        codeLocked: 'Too many wrong codes. Sign in again to get a new code.',
        codeExpired: 'The code has expired. Sign in again to get a new code.',
        trustBrowser: 'Trust this browser for 30 days',
        trustBrowserHint: 'Until {date} we will not ask for an email code in this browser.',
        resend: 'Send code again',
        resendIn: 'You can resend in {seconds} s',
        resent: 'New code sent; the previous code is no longer valid.',
        notMeLink: 'This was not me',
        noPendingCode: 'There is no pending sign-in. Please sign in first.',
        networkConfirmIntro: 'Confirm the new trusted network with the 6-digit code we sent to {email}.',
        registerTitle: 'Create account',
        passwordHint: 'At least 12 characters.',
        passwordTooShort: 'Use at least 12 characters.',
        passwordTooLong: 'Use at most 256 characters.',
        emailInvalid: 'Check your email address.',
        passwordRepeat: 'Repeat password',
        passwordMismatch: 'The passwords do not match.',
        registerDone: 'Check your email',
        registerDoneText: 'We sent a confirmation link to {email}. Click it to activate your account.',
        alreadyAccount: 'Already have an account?',
        emailTaken: 'An account with this email address already exists.',
        passwordBreached: 'This password appears in a data breach. Choose another password.',
        privateEmailHint: 'Tip: use a private email address, not your work address.',
        verifyTitle: 'Confirm email address',
        verifyIntro: 'Click the button to confirm your email address.',
        verifyButton: 'Confirm',
        verifying: 'Confirming…',
        verifyDone: 'Your email address is confirmed. You can now sign in.',
        verifyInvalid: 'This link is invalid or has expired.',
        tokenMissing: 'The link is missing a token. Open the link from the email again.',
        toLogin: 'Go to sign in',
        resetTitle: 'Forgot password',
        resetIntro: 'Enter your email address. If an account exists, we will send a link to change your password (valid for 60 minutes).',
        resetSend: 'Send link',
        resetSent: 'If an account exists for {email}, an email is on its way.',
        resetConfirmTitle: 'New password',
        newPassword: 'New password',
        resetConfirmButton: 'Change password',
        resetDone: 'Your password has been changed. All trusted browsers were forgotten; at the next sign-in we will ask for an email code again.',
        resetInvalid: 'This reset link is invalid or has expired.',
        notMeTitle: 'This was not me',
        notMeIntro: 'Someone tried to sign in with your password. If that was not you, we will lock down your account.',
        notMeWhatHappens: 'What happens when you press the button:',
        notMeStep1: 'The pending sign-in attempt is blocked.',
        notMeStep2: {
            one: '{count} trusted browser is forgotten.',
            other: '{count} trusted browsers are forgotten.',
        },
        notMeStep2Unknown: 'All trusted browsers are forgotten.',
        notMeStep3: {
            one: '{count} pending sign-in code becomes invalid.',
            other: '{count} pending sign-in codes become invalid.',
        },
        notMeStep4: 'You receive an email to choose a new password.',
        notMeButton: 'Yes, this was not me',
        notMeDone: 'Done. Check your email for the link to choose a new password.',
        notMeInvalid: 'This link is invalid or has already been used.',
        stepUpTitle: 'Confirm with your password',
        stepUpIntro: 'For this action we ask for your password again, even at home. It is valid for 10 minutes.',
        stepUpButton: 'Confirm',
        stepUpWrong: 'Password is incorrect.',
        stepUpCancelled: 'Action cancelled.',
        wizardTitle: 'Set up your household',
        wizardIntro: 'A few things to get started; everything can be changed later.',
        wizardHouseholdName: 'Household name',
        wizardHouseholdHint: 'Shown at the top of the board, for example "The Smiths".',
        wizardYou: 'Your name on the board',
        wizardPinTitle: 'Parent PIN',
        wizardPinPlaceholder: 'Coming later: you set the PIN for parent mode on the tablet here, with a password confirmation.',
        wizardInviteTitle: 'Invite second parent',
        wizardInvitePlaceholder: 'Coming later: invite by email; the other parent gets the same rights in this household.',
        wizardTrustTitle: 'Trust this network',
        wizardTrustHint: 'Set this up under Security: then we will not ask for an email code at home.',
        wizardSaved: 'Household saved.',
        householdNameRequired: 'Enter a name.',
        todayTitle: 'Today',
        todayEmpty: 'Nothing planned today.',
        tasksTitle: 'Tasks',
        tasksEmpty: 'No tasks for today.',
        allDay: 'All day',
        everyone: 'Everyone',
        doneBy: 'Done',
        quickAdd: 'Quick add',
        agendaTitle: 'Calendar',
        newEvent: 'Quick event',
        newTask: 'Quick task',
        title: 'Title',
        date: 'Date',
        start: 'Start',
        duration: 'Duration (minutes)',
        forWhom: 'For whom',
        allDayLabel: 'All day',
        icon: 'Icon',
        iconNone: 'No icon',
        location: 'Location',
        createEvent: 'Add event',
        createTask: 'Add task',
        eventCreated: 'Event added.',
        taskCreated: 'Task added.',
        titleRequired: 'Enter a title.',
        titleTooLong: 'At most 120 characters.',
        dateInvalid: 'Choose a valid date (YYYY-MM-DD).',
        memberRequired: 'Choose at least one member.',
        startInvalid: 'Choose a start time (HH:MM).',
        durationInvalid: 'Duration is at least 5 and at most 1440 minutes.',
        listFor: 'Calendar for {date}',
        showDay: 'Show',
        deleteEvent: 'Delete event',
        deleteTask: 'Delete task',
        itemDeleted: 'Deleted.',
        noEventsDay: 'No events on this day.',
        noTasksDay: 'No tasks on this day.',
        membersTitle: 'Members',
        membersIntro: 'Everyone on the board, with or without a login.',
        addMember: 'Add member',
        editMember: 'Edit member',
        memberName: 'Name',
        memberKind: 'Kind',
        kindAdult: 'Adult',
        kindChild: 'Child',
        kindHelper: 'Helper',
        color: 'Colour',
        avatarIcon: 'Avatar icon',
        ageBand: 'Age band',
        ageBandNone: 'Not set',
        nameRequired: 'Enter a name.',
        nameTooLong: 'At most 40 characters.',
        memberSaved: 'Member saved.',
        colorNames: {
            orange: 'Orange',
            skyblue: 'Sky blue',
            bluishgreen: 'Bluish green',
            yellow: 'Yellow',
            blue: 'Blue',
            vermillion: 'Vermillion',
            reddishpurple: 'Reddish purple',
            black: 'Black',
        },
        devicesTitle: 'Devices',
        devicesEmpty: 'No tablet paired yet.',
        pairDevice: 'Pair',
        deviceName: 'Name',
        room: 'Room',
        status: 'Status',
        lastSeen: 'Last seen',
        lastSync: 'Last sync',
        statusActive: 'Active',
        statusRevoked: 'Revoked',
        statusSuspect: 'Suspect',
        online: 'Online',
        offline: 'Offline',
        never: 'Never',
        justNow: 'just now',
        minutesAgo: { one: '{count} minute ago', other: '{count} minutes ago' },
        hoursAgo: { one: '{count} hour ago', other: '{count} hours ago' },
        daysAgo: { one: '{count} day ago', other: '{count} days ago' },
        rename: 'Rename',
        revoke: 'Revoke',
        revokeConfirm: 'Are you sure you want to revoke "{name}"? The tablet will show the pairing screen within a minute.',
        revokeYes: 'Yes, revoke',
        deviceRevoked: 'Device revoked.',
        deviceSaved: 'Device saved.',
        appVersion: 'Version',
        standalone: 'Home screen app',
        swState: 'Service worker',
        storageOk: 'Storage',
        clockOffset: 'Clock offset',
        pairTitle: 'Pair tablet',
        pairIntro: 'Enter the code shown on the tablet.',
        pairCode: 'Code',
        pairReviewIntro: 'Check the code on your tablet, then choose its name and room.',
        pairConnect: 'Connect this tablet',
        pairMatch: 'Does this code match the code on your tablet?',
        pairChangeCode: 'Enter another code',
        pairDetails: 'Device details',
        pairNameLabel: 'Name your tablet',
        pairNameHint: 'You can change this name later.',
        pairNext: 'Return to your tablet. The board opens there automatically.',
        pairCodeInvalid: 'The code has 8 characters, for example 1234-5678.',
        pairLookup: 'Check code',
        pairNotFound: 'Unknown or expired code. Check the code on the tablet.',
        pairTooMany: 'Too many wrong codes in this session. Sign in again.',
        pairUserAgent: 'Browser',
        pairPlatform: 'Platform',
        pairCountry: 'Country',
        pairStarted: 'Started',
        pairUnknown: 'unknown',
        pairApprove: 'Approve',
        pairApproved: 'Tablet "{name}" paired. The board appears within a few seconds.',
        roomRequired: 'Choose a room.',
        toDevices: 'Go to devices',
        securityTitle: 'Security',
        trustedNetworksTitle: 'Trusted networks',
        trustedNetworksIntro: 'On a trusted network we do not ask for an email code; your password is always required.',
        trustThisNetwork: 'Trust this network',
        trustServerWan: "Trust the server's internet address",
        currentPrefix: 'You are currently on {prefix}',
        serverWanLabel: "Server's internet address: {ip}",
        currentPrefixUnknown: 'Your internet address is unknown.',
        networkNoSuggestion: 'This network cannot be added as a trusted network (for example a local or shared provider network).',
        networkAlreadyTrusted: 'This network is already trusted.',
        addNetwork: 'Add network',
        label: 'Label',
        labelRequired: 'Enter a label.',
        kind: 'Kind',
        kindCidr: 'Network (CIDR, e.g. 192.168.1.0/24)',
        kindIp: 'Single address (IPv4)',
        kindServerWan: "Server's internet address (follows automatically)",
        kindDdns: 'DDNS hostname',
        value: 'Value',
        valueInvalid: 'Invalid value for this kind of network.',
        valueIpv6: 'IPv6 is not supported yet.',
        valueCgnat: 'This address belongs to a shared carrier network (CGNAT) and cannot be trusted.',
        scope: 'Applies to',
        scopeHousehold: 'The whole household',
        scopeIdentity: 'Only me',
        rememberDefault: '"Stay signed in" is on by default on this network',
        officeWarning: 'Everyone behind this address skips the email check — is this a fixed business address?',
        mobileHint: 'On mobile or 4G? Prefer "Trust this browser for 30 days" when signing in.',
        networkCreated: 'Network added. Confirm it with the email code.',
        networkConfirmed: 'Network confirmed. On this network we no longer ask for an email code.',
        unconfirmed: 'Not confirmed yet',
        confirmedAt: 'Confirmed',
        lastMatched: 'Last matched',
        disabledLabel: 'Off',
        enabledLabel: 'On',
        disable: 'Turn off',
        enable: 'Turn on',
        thisNetwork: 'this network',
        noNetworks: 'No trusted networks yet.',
        trustedBrowsersTitle: 'Trusted browsers',
        trustedBrowsersIntro: 'After password + email code we trust a browser for 30 days; after that we ask for a code again.',
        thisBrowser: 'This browser',
        issued: 'Issued',
        trustedUntil: 'Trusted until {date}',
        lastUsedAt: 'last used {when}',
        expiresOn: 'expires {date}',
        todayAt: 'today {time}',
        yesterdayAt: 'yesterday {time}',
        expires: 'Expires',
        lastUsed: 'Last used',
        forget: 'Forget',
        forgetOthers: 'Forget all other browsers',
        noTrustedBrowsers: 'No trusted browsers.',
        browserForgotten: 'Browser forgotten.',
        sessionsTitle: 'Sessions',
        routeLabel: 'Route',
        routeBrowser: 'trusted browser',
        routeNetwork: 'trusted network',
        routeOnce: 'one-off (24 hours)',
        routeNone: 'none',
        thisSession: 'This session',
        revokeSession: 'Revoke',
        logoutEverywhere: 'Sign out everywhere',
        logoutForget: 'Sign out and forget this browser',
        sessionRevoked: 'Session revoked.',
    },
};
//# sourceMappingURL=en.js.map